import React from 'react';

// ...

export const Page = ({ component: PageComponent }) => {
  const getLayout = PageComponent.pageProps?.getLayout || ((PageComponent) => <PageComponent />);

  return getLayout(PageComponent);
};
